import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { format_date_technical } from '../../functions/functions_formatting.js';


export default class Payoutlist extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {

        return (
            <div className="admindashboard__section">
                <div className="admindashboard__section__title text-title">
                    Payouts
                </div>
                <div className="admindashboard__section__content">
                    {(this.props.data && this.props.data.length >= 1) &&
                        <div className="admindashboard__section__content__table admindashboard__section__content__table--payouts">

                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Amout
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Period start
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Period end
                            </div>
                            <div className="admindashboard__section__content__table__element admindashboard__section__content__table__element--header">
                                Created
                            </div>

                            {this.props.data.map((el, i) => (
                                <React.Fragment key={i}>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.amount ? el.amount : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.period_start ? format_date_technical(el.period_start) : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.period_end ? format_date_technical(el.period_end) : "-"}
                                    </div>
                                    <div className="admindashboard__section__content__table__element">
                                        {el.created ? format_date_technical(el.created) : "-"}
                                    </div>
                                </React.Fragment>
                            ))}

                        </div>
                    }
                </div>
            </div>
        )
    }
}